import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-rotate-2",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path stroke=\"none\" d=\"M0 0h24v24H0z\" fill=\"none\"></path><path d=\"M15 4.55a8 8 0 0 0 -6 14.9m0 -4.45v5h-5\"></path><path d=\"M18.37 7.16l0 .01\"></path><path d=\"M13 19.94l0 .01\"></path><path d=\"M16.84 18.37l0 .01\"></path><path d=\"M19.37 15.1l0 .01\"></path><path d=\"M19.94 11l0 .01\"></path>", 7)
const _hoisted_9 = [
  _hoisted_2
]
const _hoisted_10 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-rotate-clockwise-2",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<path stroke=\"none\" d=\"M0 0h24v24H0z\" fill=\"none\"></path><path d=\"M9 4.55a8 8 0 0 1 6 14.9m0 -4.45v5h5\"></path><path d=\"M5.63 7.16l0 .01\"></path><path d=\"M4.06 11l0 .01\"></path><path d=\"M4.63 15.1l0 .01\"></path><path d=\"M7.16 18.37l0 .01\"></path><path d=\"M11 19.94l0 .01\"></path>", 7)
const _hoisted_18 = [
  _hoisted_11
]
const _hoisted_19 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-flip-vertical",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("path", { d: "M12 3l0 18" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("path", { d: "M16 7l0 10l5 0l-5 -10" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("path", { d: "M8 7l0 10l-5 0l5 -10" }, null, -1)
const _hoisted_24 = [
  _hoisted_20,
  _hoisted_21,
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = {
  key: 3,
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-flip-horizontal",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("path", { d: "M3 12l18 0" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("path", { d: "M7 16l10 0l-10 5l0 -5" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("path", { d: "M7 8l10 0l-10 -5l0 5" }, null, -1)
const _hoisted_30 = [
  _hoisted_26,
  _hoisted_27,
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = {
  key: 4,
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-zoom-in",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_32 = /*#__PURE__*/_createStaticVNode("<path stroke=\"none\" d=\"M0 0h24v24H0z\" fill=\"none\"></path><path d=\"M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0\"></path><path d=\"M7 10l6 0\"></path><path d=\"M10 7l0 6\"></path><path d=\"M21 21l-6 -6\"></path>", 5)
const _hoisted_37 = [
  _hoisted_32
]
const _hoisted_38 = {
  key: 5,
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-zoom-out",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("path", { d: "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" }, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("path", { d: "M7 10l6 0" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("path", { d: "M21 21l-6 -6" }, null, -1)
const _hoisted_43 = [
  _hoisted_39,
  _hoisted_40,
  _hoisted_41,
  _hoisted_42
]


export default /*#__PURE__*/_defineComponent({
  __name: 'CropperIconsComponent',
  props: {
  type: {
    type: String,
    default: ""
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.type == 'rotate-anticlockwise')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_9))
      : _createCommentVNode("", true),
    (__props.type == 'rotate-clockwise')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_10, _hoisted_18))
      : _createCommentVNode("", true),
    (__props.type == 'flip-vertical')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_19, _hoisted_24))
      : _createCommentVNode("", true),
    (__props.type == 'flip-horizontal')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_25, _hoisted_30))
      : _createCommentVNode("", true),
    (__props.type == 'zoom-in')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_31, _hoisted_37))
      : _createCommentVNode("", true),
    (__props.type == 'zoom-out')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_38, _hoisted_43))
      : _createCommentVNode("", true)
  ]))
}
}

})